/* RHÔME — comportements des sections personnalisées */
(function () {
  'use strict';

  /* ---- Onglets Homme / Femme ---- */
  function initTabs(root) {
    root.querySelectorAll('.rh-tabs button[data-rh-tab]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var scope = btn.closest('.rh');
        if (!scope) return;
        scope.querySelectorAll('.rh-tabs button[data-rh-tab]').forEach(function (b) {
          b.setAttribute('aria-selected', 'false');
        });
        scope.querySelectorAll('.rh-pane').forEach(function (p) { p.classList.remove('is-on'); });
        btn.setAttribute('aria-selected', 'true');
        var pane = scope.querySelector('#' + btn.getAttribute('data-rh-tab'));
        if (pane) pane.classList.add('is-on');
      });
    });
  }

  /* ---- Carrousels ---- */
  function initCarousels(root) {
    root.querySelectorAll('.rh-carou').forEach(function (carou) {
      var track = carou.querySelector('.rh-track');
      if (!track) return;
      carou.querySelectorAll('.rh-arw').forEach(function (btn) {
        btn.addEventListener('click', function () {
          var card = track.querySelector('.rh-card');
          var step = card ? card.offsetWidth + 24 : 300;
          track.scrollBy({
            left: step * 2 * parseInt(btn.getAttribute('data-rh-dir'), 10),
            behavior: 'smooth'
          });
        });
      });
    });
  }

  /* ---- Ajout au panier depuis une carte ---- */
  function initQuickAdd(root) {
    root.querySelectorAll('.rh-sizes button[data-rh-variant]').forEach(function (btn) {
      if (btn.dataset.rhBound) return;
      btn.dataset.rhBound = '1';
      btn.addEventListener('click', function (e) {
        e.preventDefault();
        e.stopPropagation();
        var id = btn.getAttribute('data-rh-variant');
        btn.disabled = true;
        var rootUrl = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
        fetch(rootUrl + 'cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ items: [{ id: Number(id), quantity: 1 }] })
        })
          .then(function (r) { return r.json(); })
          .then(function () {
            btn.style.background = 'var(--rh-blue)';
            btn.style.color = '#fff';
            document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
            setTimeout(function () {
              btn.style.background = '';
              btn.style.color = '';
              btn.disabled = false;
            }, 900);
          })
          .catch(function () { btn.disabled = false; });
      });
    });
  }

  function initAll(root) {
    initTabs(root);
    initCarousels(root);
    initQuickAdd(root);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { initAll(document); });
  } else {
    initAll(document);
  }

  document.addEventListener('shopify:section:load', function (e) { initAll(e.target); });
})();
